export default __webpack_public_path__ + "static/nick_brown-59375cc9cf046fda98fa9554c3497ebd.jpg";